/* eslint-disable jsx-a11y/click-events-have-key-events */
import { memo, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
// Import Hooks
import useData from 'hooks/UseData';
import useBonusById from 'hooks/UseBonusById';
// Import Constants
import { l } from 'constants/common';
// Import Components
import { CJInfoBlockLabelValueWrapper } from 'components/CustomerJourney/infoBlocks';
import BonusModal from 'components/BonusModal';

const CJPartnerBonusIdInfoBlock = ({ data, customAttributes: _customAttributes }) => {
    const { t } = useTranslation();
    const dataValue = useData(data);

    const { bonusData, isLoading } = useBonusById(dataValue?.value);
    const [isVisibleBonusInfo, setIsVisibleBonusInfo] = useState(false);

    const openBonusModal = () => {
        setIsVisibleBonusInfo(true);
    };

    return (
        <>
            <CJInfoBlockLabelValueWrapper label={t(l.Id)} value={dataValue?.value} />
            <CJInfoBlockLabelValueWrapper
                label={t(l.Name)}
                value={bonusData?.Name}
                isLoading={isLoading}
                onClick={openBonusModal}
                isClickable={true}
            />

            {isVisibleBonusInfo && (
                <BonusModal
                    bonusId={dataValue?.value}
                    handleClose={() => setIsVisibleBonusInfo(false)}
                    isVisible={isVisibleBonusInfo}
                />
            )}
        </>
    );
};

CJPartnerBonusIdInfoBlock.propTypes = {
    data: PropTypes.object.isRequired,
    customAttributes: PropTypes.object.isRequired,
};

export default memo(CJPartnerBonusIdInfoBlock);
